unit View.Dialog;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.WebCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, UUtils;

type
  TDialog = class(TForm)
    div_warning: THTMLDiv;
    div_alert: THTMLDiv;
    div_success: THTMLDiv;
    div_error: THTMLDiv;
    btnConfirmarOk: TButton;
    btnCancelar: TButton;
    lblInformacao: TLabel;
    lblMensagem: TLabel;
    div_question: THTMLDiv;
    procedure WebFormShow(Sender: TObject);
    procedure btnCancelarClick(Sender: TObject);
    procedure btnConfirmarOkClick(Sender: TObject);
    procedure WebFormCloseQuery(Sender: TObject; var CanClose: Boolean);
  private
    { Private declarations }
  public
  var
    FTipo : TTipoDialogo;
    FResult : Boolean;
    FMensagem : string;
  protected procedure LoadDFMValues; override; end;

var
  Dialog: TDialog;

implementation

{$R *.dfm}

procedure TDialog.btnCancelarClick(Sender: TObject);
begin
  FResult := False;
  Close;
end;

procedure TDialog.btnConfirmarOkClick(Sender: TObject);
begin
  FResult := True;
  Close;
end;

procedure TDialog.WebFormCloseQuery(Sender: TObject; var CanClose: Boolean);
begin
  if (Pos('O tempo de conexão expirou!', FMensagem) > 0) or (Pos('Usuário não possui permissão', FMensagem) > 0)
    or (FMensagem = 'O token informado na requisição é inválido!') then
  begin
    CanClose := False;
    document.location.reload(true);
  end
  else if Pos('#recarregar_pagina_principal#', FMensagem) > 0 then
  begin
    CanClose := False;
    asm
      window.location.hash = '';
      window.location.reload();
    end;
  end
  else
  begin
    asm
      document.body.style.overflow = '';
    end;
  end;
end;

procedure TDialog.WebFormShow(Sender: TObject);
var
  lTipoBotao : string;
begin
  lblMensagem.HTML := FMensagem.Replace('#recarregar_pagina_principal#', '');

  if FTipo = TTipoDialogo.SUCESSO then
  begin
    lTipoBotao := 'btn-success';
    div_success.Visible := True;
    lblInformacao.Caption := 'Sucesso';
  end
  else if FTipo = TTipoDialogo.ERROR then
  begin
    div_error.Visible := True;
    lTipoBotao := 'btn-danger';
    lblInformacao.Caption := 'Erro';
  end
  else if FTipo = TTipoDialogo.CONFIRMACAO then
  begin
    div_question.Visible := True;
    btnConfirmarOk.Caption := 'Confirmar';
    btnCancelar.Visible := True;
    lTipoBotao := 'btn-success';
    lblInformacao.Caption := 'Confirmação';
  end
  else if FTipo = TTipoDialogo.INFORMACAO then
  begin
    lTipoBotao := 'btn-primary';
    div_alert.Visible := True;
    lblInformacao.Caption := 'Informação';
  end;

  asm
    document.body.style.overflow = 'hidden';
    $('#btnConfirmar').addClass(lTipoBotao);

    const spans = document.querySelectorAll('span');

    spans.forEach(span => {
    if (window.getComputedStyle(span).opacity === '0.2') {
    span.style.position = 'fixed';
    }
    });
  end;
end;

procedure TDialog.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lblInformacao := TLabel.Create('lblInformacao');
  lblMensagem := TLabel.Create('lblMensagem');
  div_warning := THTMLDiv.Create('warning');
  div_alert := THTMLDiv.Create('alert');
  div_success := THTMLDiv.Create('success');
  div_error := THTMLDiv.Create('error');
  btnConfirmarOk := TButton.Create('btnConfirmar');
  btnCancelar := TButton.Create('btnCancelar');
  div_question := THTMLDiv.Create('question');

  lblInformacao.BeforeLoadDFMValues;
  lblMensagem.BeforeLoadDFMValues;
  div_warning.BeforeLoadDFMValues;
  div_alert.BeforeLoadDFMValues;
  div_success.BeforeLoadDFMValues;
  div_error.BeforeLoadDFMValues;
  btnConfirmarOk.BeforeLoadDFMValues;
  btnCancelar.BeforeLoadDFMValues;
  div_question.BeforeLoadDFMValues;
  try
    Name := 'Dialog';
    Width := 431;
    Height := 300;
    ElementPopupClassName := 'rounded-3';
    Visible := True;
    SetEvent(Self, 'OnCloseQuery', 'WebFormCloseQuery');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lblInformacao.SetParentComponent(Self);
    lblInformacao.Name := 'lblInformacao';
    lblInformacao.Left := 8;
    lblInformacao.Top := 176;
    lblInformacao.Width := 23;
    lblInformacao.Height := 15;
    lblInformacao.Caption := 'Tipo';
    lblInformacao.HeightPercent := 100.000000000000000000;
    lblInformacao.WidthPercent := 100.000000000000000000;
    lblMensagem.SetParentComponent(Self);
    lblMensagem.Name := 'lblMensagem';
    lblMensagem.Left := 8;
    lblMensagem.Top := 216;
    lblMensagem.Width := 3;
    lblMensagem.Height := 15;
    lblMensagem.HeightPercent := 100.000000000000000000;
    lblMensagem.WidthPercent := 100.000000000000000000;
    div_warning.SetParentComponent(Self);
    div_warning.Name := 'div_warning';
    div_warning.Left := 8;
    div_warning.Top := 8;
    div_warning.Width := 100;
    div_warning.Height := 41;
    div_warning.Role := '';
    div_warning.Visible := False;
    div_alert.SetParentComponent(Self);
    div_alert.Name := 'div_alert';
    div_alert.Left := 114;
    div_alert.Top := 8;
    div_alert.Width := 100;
    div_alert.Height := 41;
    div_alert.ChildOrder := 1;
    div_alert.Role := '';
    div_alert.Visible := False;
    div_success.SetParentComponent(Self);
    div_success.Name := 'div_success';
    div_success.Left := 220;
    div_success.Top := 8;
    div_success.Width := 100;
    div_success.Height := 41;
    div_success.ChildOrder := 1;
    div_success.Role := '';
    div_success.Visible := False;
    div_error.SetParentComponent(Self);
    div_error.Name := 'div_error';
    div_error.Left := 8;
    div_error.Top := 55;
    div_error.Width := 100;
    div_error.Height := 41;
    div_error.ChildOrder := 1;
    div_error.Role := '';
    div_error.Visible := False;
    btnConfirmarOk.SetParentComponent(Self);
    btnConfirmarOk.Name := 'btnConfirmarOk';
    btnConfirmarOk.Left := 8;
    btnConfirmarOk.Top := 120;
    btnConfirmarOk.Width := 73;
    btnConfirmarOk.Height := 25;
    btnConfirmarOk.Caption := 'Ok';
    btnConfirmarOk.ChildOrder := 4;
    btnConfirmarOk.HeightPercent := 100.000000000000000000;
    btnConfirmarOk.WidthPercent := 100.000000000000000000;
    SetEvent(btnConfirmarOk, Self, 'OnClick', 'btnConfirmarOkClick');
    btnCancelar.SetParentComponent(Self);
    btnCancelar.Name := 'btnCancelar';
    btnCancelar.Left := 96;
    btnCancelar.Top := 120;
    btnCancelar.Width := 89;
    btnCancelar.Height := 25;
    btnCancelar.Caption := 'Cancelar';
    btnCancelar.ChildOrder := 5;
    btnCancelar.HeightPercent := 100.000000000000000000;
    btnCancelar.Visible := False;
    btnCancelar.WidthPercent := 100.000000000000000000;
    SetEvent(btnCancelar, Self, 'OnClick', 'btnCancelarClick');
    div_question.SetParentComponent(Self);
    div_question.Name := 'div_question';
    div_question.Left := 114;
    div_question.Top := 55;
    div_question.Width := 100;
    div_question.Height := 41;
    div_question.ChildOrder := 1;
    div_question.Role := '';
    div_question.Visible := False;
  finally
    lblInformacao.AfterLoadDFMValues;
    lblMensagem.AfterLoadDFMValues;
    div_warning.AfterLoadDFMValues;
    div_alert.AfterLoadDFMValues;
    div_success.AfterLoadDFMValues;
    div_error.AfterLoadDFMValues;
    btnConfirmarOk.AfterLoadDFMValues;
    btnCancelar.AfterLoadDFMValues;
    div_question.AfterLoadDFMValues;
  end;
end;

end.